import { render, staticRenderFns } from "./ResultSkele.vue?vue&type=template&id=4f4d2cb3&scoped=true&"
import script from "./ResultSkele.vue?vue&type=script&lang=js&"
export * from "./ResultSkele.vue?vue&type=script&lang=js&"
import style0 from "./ResultSkele.vue?vue&type=style&index=0&id=4f4d2cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d2cb3",
  null
  
)

export default component.exports